import './not-found.scss';
import { setupLayout } from '../Shared/layout';

setupLayout();